var _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _ellipse2, _ellipse3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPass2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 24.4783L8 55.5217C8 57.4427 9.55727 59 11.4783 59H50.6112C51.5029 59 52.3604 58.6576 53.0069 58.0435L54 57.1L54.9931 58.0435C55.6396 58.6576 56.4972 59 57.3888 59H64.5217C66.4427 59 68 57.4427 68 55.5217V24.4783C68 22.5573 66.4427 21 64.5217 21H57.3888C56.4972 21 55.6396 21.3424 54.9931 21.9565L54 22.9L53.0069 21.9565C52.3604 21.3424 51.5028 21 50.6112 21L11.4783 21C9.55727 21 8 22.5573 8 24.4783Z",
    fill: "#3451D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54 23.125V56.875",
    stroke: "#1C339B",
    strokeWidth: 0.9375,
    strokeDasharray: "1.88 1.88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9171 36.0156H20.0073C19.661 36.0156 19.3391 36.194 19.1556 36.4877L17.1589 39.6823C17.0184 39.9072 16.9724 40.1786 17.0312 40.4373L19.0952 49.5189C19.3031 50.4335 20.1162 51.0826 21.0542 51.0826H40.9497C41.8877 51.0826 42.7008 50.4335 42.9087 49.5189L44.9727 40.4373C45.0315 40.1786 44.9856 39.9072 44.845 39.6823L42.8484 36.4877C42.6648 36.194 42.3429 36.0156 41.9966 36.0156H39.0868C38.7434 36.0156 38.4238 36.1911 38.2394 36.4808L35.3158 41.075C35.1315 41.3647 34.8118 41.5402 34.4684 41.5402H27.5355C27.1921 41.5402 26.8724 41.3647 26.6881 41.075L23.7645 36.4808C23.5801 36.1911 23.2605 36.0156 22.9171 36.0156Z",
    fill: "#FFCE51"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2038 43.5303C23.3181 43.3213 23.6183 43.3213 23.7326 43.5303L24.3137 44.5928C24.3413 44.6433 24.3829 44.6849 24.4335 44.7126L25.4959 45.2937C25.7049 45.408 25.7049 45.7081 25.496 45.8224L24.4335 46.4035C24.3829 46.4312 24.3413 46.4727 24.3137 46.5233L23.7326 47.5858C23.6183 47.7948 23.3181 47.7948 23.2038 47.5858L22.6227 46.5233C22.5951 46.4727 22.5535 46.4312 22.5029 46.4035L21.4404 45.8224C21.2314 45.7081 21.2314 45.408 21.4404 45.2937L22.5029 44.7126C22.5535 44.6849 22.5951 44.6433 22.6227 44.5928L23.2038 43.5303Z",
    fill: "#3451D7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2702 43.5303C38.3845 43.3213 38.6847 43.3213 38.799 43.5303L39.3801 44.5928C39.4077 44.6433 39.4493 44.6849 39.4999 44.7126L40.5624 45.2937C40.7713 45.408 40.7713 45.7081 40.5624 45.8224L39.4999 46.4035C39.4493 46.4312 39.4077 46.4727 39.3801 46.5233L38.799 47.5858C38.6847 47.7948 38.3845 47.7948 38.2702 47.5858L37.6891 46.5233C37.6615 46.4727 37.6199 46.4312 37.5693 46.4035L36.5068 45.8224C36.2978 45.7081 36.2978 45.408 36.5068 45.2937L37.5693 44.7126C37.6199 44.6849 37.6615 44.6433 37.6891 44.5928L38.2702 43.5303Z",
    fill: "#3451D7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.737 28.4639C30.8513 28.2549 31.1515 28.2549 31.2658 28.4639L33.0898 31.799C33.1175 31.8496 33.1591 31.8912 33.2096 31.9188L36.5448 33.7429C36.7538 33.8572 36.7538 34.1573 36.5448 34.2716L33.2096 36.0957C33.1591 36.1233 33.1175 36.1649 33.0898 36.2155L31.2658 39.5506C31.1515 39.7596 30.8513 39.7596 30.737 39.5506L28.913 36.2155C28.8853 36.1649 28.8437 36.1233 28.7932 36.0957L25.458 34.2716C25.249 34.1573 25.249 33.8572 25.458 33.7429L28.7932 31.9188C28.8437 31.8912 28.8853 31.8496 28.913 31.799L30.737 28.4639Z",
    fill: "#FFCE51"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 62C52 56.4771 56.4772 52 62 52C67.5228 52 72 56.4771 72 62C72 67.5228 67.5228 71.9999 62 71.9999C60.2069 71.9999 58.5216 71.5271 57.0648 70.6991L52.9828 71.7475C52.5408 71.861 52.1389 71.4591 52.2524 71.0171L53.3008 66.9351C52.4728 65.4784 52 63.7931 52 62Z",
    fill: "#8A9DF1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58,
    cy: 62,
    rx: 1,
    ry: 0.999997,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62,
    cy: 62,
    rx: 1,
    ry: 0.999997,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66,
    cy: 62,
    rx: 1,
    ry: 0.999997,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPass2);
export default __webpack_public_path__ + "static/media/pass2.513b6a34c49e1fe544fead1341df3351.svg";
export { ForwardRef as ReactComponent };